type PlanKey = {
  [key: string]: string;
};

export const planPeriodKey: PlanKey = {
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
};

export const planTierKey: PlanKey = {
  FREE: 'Free',
  PRO: 'Pro',
  TEAM: 'Team',
  BUSINESS: 'Business',
  ENTERPRISE: 'Enterprise',
};

/**
 * This data is not available in the GraphQL API, so we need to use a constant.
 */
export const enterpriseMountedStorageLimitBytes = 2_000_000_000_000; // 2 TB
